import styled from "styled-components";
import { ContentCard, PageContainer, PageHeader, PrimaryButton } from "../empresas/Empresas";

export default function Clinicas() {
  return (
    <PageContainer>
      <PageHeader>
        <div>
          <h1>Clínicas</h1>
          <p>Cadastro e gerenciamento das clínicas.</p>
        </div>

        <PrimaryButton type="button">
          Nova Clínica
        </PrimaryButton>
      </PageHeader>

      <ContentCard>
        <h2>Clínicas cadastradas</h2>
        <p>A listagem das clínicas será exibida aqui.</p>
      </ContentCard>
    </PageContainer>
  );
}